import { datadogLogs } from '@datadog/browser-logs';
import Cookie from 'js-cookie';

import CONFIG from '../core/config';

if (CONFIG.datadog) {
  datadogLogs.init({
    clientToken: CONFIG.datadog.clientToken,
    site: 'datadoghq.eu',
    service: 'app-desktop',
    env: CONFIG.environmentName,
    sessionSampleRate: 100,
    version: process.env.REACT_APP_SHA,
    forwardErrorsToLogs: false,
    // Note: consent is not passed here because datadog logs are considered as essential
  });
}

export const addSpendeskContextToDatadogLogs = ({
  userId,
  companyId,
}: {
  userId?: string;
  companyId?: string;
}) => {
  if (CONFIG.datadog && Boolean(datadogLogs.getInitConfiguration())) {
    datadogLogs.setGlobalContextProperty('userId', userId);
    datadogLogs.setGlobalContextProperty('companyId', companyId);
    datadogLogs.setGlobalContextProperty(
      'deviceId',
      Cookie.get('spendeskDeviceUUID'),
    );
  }
};
